// =============================================================================
// SimSense Platform — Weekly Challenges Page
// =============================================================================

import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../utils/api";

export function Challenges() {
  const [challenges, setChallenges] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchChallenges() {
      try {
        const data = await api<any[]>("/api/challenges");
        setChallenges(data || []);
      } catch (err) {
        console.error("Failed to fetch challenges", err);
      } finally {
        setLoading(false);
      }
    }
    fetchChallenges();
  }, []);

  if (loading) return <div style={{ padding: "40px", textAlign: "center" }}>Loading challenges...</div>;

  return (
    <div style={{ maxWidth: "1000px", margin: "0 auto" }}>
      <div style={{ marginBottom: "32px" }}>
        <h2 style={{ fontSize: "28px", marginBottom: "8px" }}>Weekly Challenges</h2>
        <p style={{ color: "var(--text2)" }}>Compete with the community on specific track/car combinations to climb the rankings.</p>
      </div>

      {challenges.length === 0 ? (
        <div style={{ padding: "80px", textAlign: "center", background: "var(--card)", borderRadius: "12px", border: "1px solid var(--border)" }}>
          <div style={{ fontSize: "48px", marginBottom: "24px" }}>🏁</div>
          <h3 style={{ fontSize: "20px", marginBottom: "12px" }}>No Active Challenges</h3>
          <p style={{ color: "var(--text2)" }}>Check back soon for the next event!</p>
        </div>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
          {challenges.map(challenge => (
            <div 
              key={challenge.id}
              style={{ 
                background: "var(--card)", 
                padding: "32px", 
                borderRadius: "12px", 
                border: "1px solid var(--border)",
                display: "grid",
                gridTemplateColumns: "1fr 200px",
                gap: "32px",
                alignItems: "center"
              }}
            >
              <div>
                <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "12px" }}>
                  <span style={{ 
                    background: "var(--accent)", 
                    color: "#fff", 
                    padding: "2px 8px", 
                    borderRadius: "4px", 
                    fontSize: "10px", 
                    fontWeight: 700, 
                    textTransform: "uppercase",
                    letterSpacing: "0.5px"
                  }}>
                    Active Now
                  </span>
                  <span style={{ fontSize: "12px", color: "var(--text3)" }}>
                    Ends {new Date(challenge.endAt).toLocaleDateString()}
                  </span>
                </div>
                <h3 style={{ fontSize: "24px", marginBottom: "8px", color: "#fff" }}>{challenge.title}</h3>
                <p style={{ color: "var(--text2)", fontSize: "15px", marginBottom: "24px", lineHeight: "1.6" }}>{challenge.description}</p>
                
                <div style={{ display: "flex", gap: "24px" }}>
                  <div>
                    <div style={{ fontSize: "10px", color: "var(--text3)", textTransform: "uppercase", marginBottom: "4px" }}>Track</div>
                    <div style={{ fontWeight: 600 }}>{challenge.trackName}</div>
                  </div>
                  <div>
                    <div style={{ fontSize: "10px", color: "var(--text3)", textTransform: "uppercase", marginBottom: "4px" }}>Vehicle</div>
                    <div style={{ fontWeight: 600 }}>{challenge.carName || "Any Car"}</div>
                  </div>
                </div>
              </div>

              <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
                <Link 
                  to={`/leaderboard?track=${encodeURIComponent(challenge.trackName)}${challenge.carName ? `&car=${encodeURIComponent(challenge.carName)}` : ""}`}
                  style={{ 
                    display: "block", 
                    textAlign: "center", 
                    padding: "12px", 
                    background: "var(--accent)", 
                    color: "#fff", 
                    borderRadius: "8px", 
                    textDecoration: "none", 
                    fontWeight: 700,
                    fontSize: "14px"
                  }}
                >
                  View Leaderboard
                </Link>
                <div style={{ fontSize: "11px", color: "var(--text3)", textAlign: "center" }}>
                  Upload any session during the event window to qualify automatically.
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
